"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataDuplicator = void 0;
const dbgate_tools_1 = require("dbgate-tools");
const pick_1 = __importDefault(require("lodash/pick"));
const omit_1 = __importDefault(require("lodash/omit"));
const logger = (0, dbgate_tools_1.getLogger)('dataDuplicator');
class DuplicatorReference {
    constructor(base, ref, isMandatory, foreignKey) {
        this.base = base;
        this.ref = ref;
        this.isMandatory = isMandatory;
        this.foreignKey = foreignKey;
    }
    get columnName() {
        return this.foreignKey.columns[0].columnName;
    }
}
class DuplicatorItemHolder {
    get name() {
        return this.item.name;
    }
    constructor(item, duplicator) {
        var _a, _b, _c, _d, _e;
        this.item = item;
        this.duplicator = duplicator;
        this.references = [];
        this.backReferences = [];
        this.isPlanned = false;
        this.idMap = {};
        this.refByColumn = {};
        this.table = duplicator.db.tables.find(x => x.pureName.toUpperCase() == item.name.toUpperCase());
        this.autoColumn = (_a = this.table.columns.find(x => x.autoIncrement)) === null || _a === void 0 ? void 0 : _a.columnName;
        if (((_c = (_b = this.table.primaryKey) === null || _b === void 0 ? void 0 : _b.columns) === null || _c === void 0 ? void 0 : _c.length) != 1 ||
            ((_e = (_d = this.table.primaryKey) === null || _d === void 0 ? void 0 : _d.columns) === null || _e === void 0 ? void 0 : _e[0].columnName) != this.autoColumn) {
            this.autoColumn = null;
        }
    }
    initializeReferences() {
        var _a, _b;
        for (const fk of this.table.foreignKeys) {
            if (((_a = fk.columns) === null || _a === void 0 ? void 0 : _a.length) != 1)
                continue;
            const refHolder = this.duplicator.itemHolders.find(y => y.name.toUpperCase() == fk.refTableName.toUpperCase());
            if (refHolder == null)
                continue;
            const isMandatory = (_b = this.table.columns.find(x => { var _a; return x.columnName == ((_a = fk.columns[0]) === null || _a === void 0 ? void 0 : _a.columnName); })) === null || _b === void 0 ? void 0 : _b.notNull;
            const newref = new DuplicatorReference(this, refHolder, isMandatory, fk);
            this.references.push(newref);
            this.refByColumn[newref.columnName] = newref;
            refHolder.isReferenced = true;
        }
    }
    createInsertObject(chunk) {
        const res = (0, omit_1.default)((0, pick_1.default)(chunk, this.table.columns.map(x => x.columnName)), [this.autoColumn, ...this.backReferences.map(x => x.columnName)]);
        for (const key in res) {
            const ref = this.refByColumn[key];
            if (ref) {
                // remap id
                res[key] = ref.ref.idMap[res[key]];
                if (ref.isMandatory && res[key] == null) {
                    // mandatory refertence not matched
                    if (this.duplicator.options.skipRowsWithUnresolvedRefs) {
                        return null;
                    }
                    throw new Error(`Unresolved reference, base=${ref.base.name}, ref=${ref.ref.name}, ${key}=${chunk[key]}`);
                }
            }
        }
        return res;
    }
    runImport() {
        return __awaiter(this, void 0, void 0, function* () {
            const readStream = yield this.item.openStream();
            const driver = this.duplicator.driver;
            const pool = this.duplicator.pool;
            let inserted = 0;
            let mapped = 0;
            let missing = 0;
            let skipped = 0;
            let lastLogged = new Date();
            const writeStream = (0, dbgate_tools_1.createAsyncWriteStream)(this.duplicator.stream, {
                processItem: (chunk) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c;
                    if (chunk.__isStreamHeader) {
                        return;
                    }
                    const doCopy = () => __awaiter(this, void 0, void 0, function* () {
                        var _d, _e, _f;
                        // console.log('chunk', this.name, JSON.stringify(chunk));
                        const insertedObj = this.createInsertObject(chunk);
                        // console.log('insertedObj', this.name, JSON.stringify(insertedObj));
                        if (insertedObj == null) {
                            skipped += 1;
                            return;
                        }
                        let res = yield (0, dbgate_tools_1.runQueryOnDriver)(pool, driver, dmp => {
                            dmp.put('^insert ^into %f (%,i) ^values (%,v)', this.table, Object.keys(insertedObj), Object.values(insertedObj));
                            if (this.autoColumn &&
                                this.isReferenced &&
                                !this.duplicator.driver.dialect.requireStandaloneSelectForScopeIdentity) {
                                dmp.selectScopeIdentity(this.table);
                            }
                        });
                        inserted += 1;
                        if (this.autoColumn && this.isReferenced) {
                            if (this.duplicator.driver.dialect.requireStandaloneSelectForScopeIdentity) {
                                res = yield (0, dbgate_tools_1.runQueryOnDriver)(pool, driver, dmp => dmp.selectScopeIdentity(this.table));
                            }
                            // console.log('IDRES', JSON.stringify(res));
                            const resId = (_f = (_e = Object.entries((_d = res === null || res === void 0 ? void 0 : res.rows) === null || _d === void 0 ? void 0 : _d[0])) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f[1];
                            if (resId != null) {
                                this.idMap[chunk[this.autoColumn]] = resId;
                            }
                        }
                    });
                    switch (this.item.operation) {
                        case 'copy': {
                            yield doCopy();
                            break;
                        }
                        case 'insertMissing':
                        case 'lookup': {
                            const res = yield (0, dbgate_tools_1.runQueryOnDriver)(pool, driver, dmp => dmp.put('^select %i ^from %f ^where %i = %v', this.autoColumn, this.table, this.item.matchColumns[0], chunk[this.item.matchColumns[0]]));
                            const resId = (_c = (_b = Object.entries((_a = res === null || res === void 0 ? void 0 : res.rows) === null || _a === void 0 ? void 0 : _a[0])) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c[1];
                            if (resId != null) {
                                mapped += 1;
                                this.idMap[chunk[this.autoColumn]] = resId;
                            }
                            else if (this.item.operation == 'insertMissing') {
                                yield doCopy();
                            }
                            else {
                                missing += 1;
                            }
                            break;
                        }
                    }
                    if (new Date().getTime() - lastLogged.getTime() > 5000) {
                        logger.info(`Duplicating ${this.item.name} in progress, inserted ${inserted} rows, mapped ${mapped} rows, missing ${missing} rows, skipped ${skipped} rows`);
                        lastLogged = new Date();
                    }
                    // this.idMap[oldId] = newId;
                }),
            });
            yield this.duplicator.copyStream(readStream, writeStream);
            // await this.duplicator.driver.writeQueryStream(this.duplicator.pool, {
            //   mapResultId: (oldId, newId) => {
            //     this.idMap[oldId] = newId;
            //   },
            // });
            return { inserted, mapped, missing, skipped };
        });
    }
}
class DataDuplicator {
    constructor(pool, driver, db, items, stream, copyStream, options = {}) {
        this.pool = pool;
        this.driver = driver;
        this.db = db;
        this.items = items;
        this.stream = stream;
        this.copyStream = copyStream;
        this.options = options;
        this.itemPlan = [];
        this.itemHolders = items.map(x => new DuplicatorItemHolder(x, this));
        this.itemHolders.forEach(x => x.initializeReferences());
    }
    findItemToPlan() {
        for (const item of this.itemHolders) {
            if (item.isPlanned)
                continue;
            if (item.references.every(x => x.ref.isPlanned)) {
                return item;
            }
        }
        for (const item of this.itemHolders) {
            if (item.isPlanned)
                continue;
            if (item.references.every(x => x.ref.isPlanned || !x.isMandatory)) {
                const backReferences = item.references.filter(x => !x.ref.isPlanned);
                item.backReferences = backReferences;
                return item;
            }
        }
        throw new Error('Cycle in mandatory references');
    }
    createPlan() {
        while (this.itemPlan.length < this.itemHolders.length) {
            const item = this.findItemToPlan();
            item.isPlanned = true;
            this.itemPlan.push(item);
        }
    }
    run() {
        return __awaiter(this, void 0, void 0, function* () {
            this.createPlan();
            yield (0, dbgate_tools_1.runCommandOnDriver)(this.pool, this.driver, dmp => dmp.beginTransaction());
            try {
                for (const item of this.itemPlan) {
                    const stats = yield item.runImport();
                    logger.info(`Duplicated ${item.name}, inserted ${stats.inserted} rows, mapped ${stats.mapped} rows, missing ${stats.missing} rows, skipped ${stats.skipped} rows`);
                }
            }
            catch (err) {
                logger.error((0, dbgate_tools_1.extractErrorLogData)(err), `Failed duplicator job, rollbacking. ${err.message}`);
                yield (0, dbgate_tools_1.runCommandOnDriver)(this.pool, this.driver, dmp => dmp.rollbackTransaction());
                return;
            }
            if (this.options.rollbackAfterFinish) {
                logger.info('Rollbacking transaction, nothing was changed');
                yield (0, dbgate_tools_1.runCommandOnDriver)(this.pool, this.driver, dmp => dmp.rollbackTransaction());
            }
            else {
                logger.info('Committing duplicator transaction');
                yield (0, dbgate_tools_1.runCommandOnDriver)(this.pool, this.driver, dmp => dmp.commitTransaction());
            }
        });
    }
}
exports.DataDuplicator = DataDuplicator;
